import { render } from "./CreateNmop.vue?vue&type=template&id=50a09bc0&scoped=true"
import script from "./CreateNmop.vue?vue&type=script&lang=js"
export * from "./CreateNmop.vue?vue&type=script&lang=js"

import "./CreateNmop.vue?vue&type=style&index=0&id=50a09bc0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a09bc0"]])

export default __exports__